import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadAjaxSectionData } from 'routes/home/redux';
// import { loadAjaxSectionData } from 'routes/home/layouts/India/redux';
import { loadAllAdsFromQueue } from 'helpers/ads/redux';
import throttle from 'lodash.throttle';
import Cookie from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import _get from 'lodash.get';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Paginate from 'components/Paginate';
import { loadGeoLocationData } from 'reduxUtils/modules/geo';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getExperimentRefresh } from 'utils/experimentUtils';
import ErrorBoundary from 'components/ErrorBoundary';
// import TimesClubWidgetLoader from 'components_v2/common/TimesClubWidget/TimesClubWidgetLoader';
// import WithPopup from 'modules/WithPopup';
import Link from 'components/Link';
import Image from 'components/Image';
import { loadToiPlusConfig } from 'reduxUtils/modules/toiPlusConfig';
import AffiliatesContent from 'components/AffiliatesContent';
import AffiliateWidgetMain from 'routes/articleshow/components/AffiliateWidget/AffiliateWidgetMain';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
// import { CORONAVIRUS_CARDS_HOME_US_JSON_URL } from 'constants/index';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
import { isTablet } from 'utils/common';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import HomePageTopLayout from 'components_v2/desktop/HomePageTopLayout/HomePageTopLayout';

// import UsElectHeader from 'components_v2/elections/UsElectHeader';
// import IframeUSElection from 'components_v2/common/IframeUSElection';
import { UserPreferenceContext, defaultUserPref } from '../../India/context';
// import LazyPlaneLayoutWithAuthor from '../../../components/desktop/PlaneLayoutWithAuthor/LazyPlaneLayoutWithAuthor';
// import PlaneLayoutWithAuthor from '../../../components/desktop/PlaneLayoutWithAuthor/PlaneLayoutWithAuthorV2';
// eslint-disable-next-line no-unused-vars
import s from '../../../Home.scss';
import CoverLayout from '../../../components/desktop/CoverLayoutV2';
import RowLayout from '../../../components/desktop/RowLayoutV2';
import SixColumnLayout from '../../../../../components_v2/desktop/SixColumnLayoutV2';
import PrimeSlider from '../../../components/desktop/PrimeSlider';
import TimesClubSlider from '../../../components/desktop/TimesClubSlider/TimesClubSlider';
import MasonryLayout from '../../../components/desktop/MasonryLayout';
import Lifestyle from '../../../components/desktop/LifestyleV2/Lifestyle';
import VideoLayout from '../../../components/desktop/VideoLayoutV2';
import Entertainment from '../../../components/desktop/EntertainmentV2';
import LinksList from '../../../../../components_v2/desktop/LinksList';
import RenderInserts from '../../../components/desktop/RenderInsertsV2/RenderInserts';
import CoronaWidget from '../../../components/desktop/CoronaWidget';
//import ElectionWidget from '../../../components/common/ElectionWidget/ElectionWidget';
//import CoronaHomePageWidget from '../../../components/common/CoronaHomePageWidget';
import Infocus from '../../../components/desktop/Infocus';
import TechSection from '../../../components/desktop/TechSection';
// eslint-disable-next-line no-unused-vars
import Iplwidget from '../../../components/desktop/Iplwidget';
// import BudgetWidgetHP from '../../../components/common/BudgetWidgetHP/BudgetWidgetHpLoader';
import RenderAds from '../../../components/desktop/RenderAds';
import CustomSlider from '../../../components/desktop/CustomSlider';
import BannerSlider from '../../../../../components_v2/desktop/BannerSlider';
// import NewscardComponent from '../../../../../components_v2/common/InitNewscardComponents/LoadableNewsCardComponent';
//import NewscardComponent from '../../../../../components_v2/common/InitNewscardComponents/LoadableNewsCardComponent';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
// import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';
import ElectionWidgetMainWrapper from '../../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

// import PlaneLayoutWithAuthor from '../../../components/mobile/PlaneLayoutWithAuthor/PlaneLayoutWithAuthor';

// import DailyPuzzles from '../../../../games/components/common/DailyPuzzles/DailyPuzzles';

// const TimesClubWidgetLoaderWithPopup = WithPopup(TimesClubWidgetLoader);

class Home extends React.Component {
  constructor() {
    super();
    this.state = {
      contextVal: { ...defaultUserPref },
      thresholds: [10, 750, 1500, 2250],
    };
    this.scrollGAElements = [];
    this.handledScrollGAElements = {};
  }
  componentDidMount() {
    this.setScrollGAElements();
    // analyticsWrapper(
    //   'gaAndGrx',
    //   'send',
    //   'event',
    //   window.categoryForGA,
    //   'Landing_NewHomePage',
    //   'USHP',
    //   { nonInteraction: 1 },
    // );
    getExperimentRefresh(this.props.refreshTime);
    this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
    window.addEventListener('scroll', this.throttledGAonScroll);
    if (
      this.state.thresholds &&
      Array.isArray(this.state.thresholds) &&
      this.state.thresholds.length > 0
    ) {
      window.addEventListener('scroll', this.handleGA4Scroll);
    }
    this.props.loadToiPlusConfig(
      this.props.currentCountry,
      this.props.isPrime,
      this.props.isWapView,
    );

    setPageConfigAndSendIBeatCall();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledGAonScroll);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.hpData &&
      this.props.hpData.sections &&
      prevProps.hpData.sections.length < this.props.hpData.sections.length
    ) {
      this.props.loadAllAdsFromQueue('', window.location.pathname);
      this.setScrollGAElements();
    }
  }

  setScrollGAElements() {
    try {
      this.scrollGAElements = [
        ...document.querySelectorAll('[data-scrollga]:not([data-scrollga=""])'),
      ];
    } catch (e) {
      // console.log(e);
    }
  }
  setViewGA4Elements = sectionItem => {
    if (
      typeof sectionItem.ga4Type !== 'undefined' &&
      sectionItem.ga4Type !== ''
    ) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: sectionItem?.ga4Type ? sectionItem?.ga4Type : '',
        category: sectionItem?.ga4Category ? sectionItem?.ga4Category : '',
      });
    }
  };

  isElementEdgesVisible = (el, skewFromBottom) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const { bottom } = rect;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (skewFromBottom) {
        return bottom <= windowHeight;
      }

      return bottom <= 0;
    }

    return false;
  };

  handleGAOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    const action = 'scroll_measure';
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (
          this.scrollGAElements[i] &&
          this.isElementEdgesVisible(this.scrollGAElements[i], true)
        ) {
          analyticsWrapper(
            'grx',
            'send',
            'event',
            window.categoryForGA,
            action,
            `Scroll_${this.scrollGAElements[i].getAttribute(
              'data-scrollga',
            )}Ends`,
            { nonInteraction: 1 },
          );

          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
          break;
        }
      }
    }
  };
  setScrollGA4State = (threshold, ga4label) => {
    this.setState(
      {
        thresholds: [
          ...this.state.thresholds.filter(item => item !== threshold),
          this.state.thresholds[this.state.thresholds.length - 1] + 750,
        ],
      },
      () => {
        if (ga4label) {
          analyticsWrapper('ga4', {
            event: 'user_scroll',
            type: 'scroll-depth',
            label:
              typeof ga4label === 'string'
                ? ga4label
                : `scroll_${threshold / 750}`,
          });
        }
      },
    );
  };

  handleGA4Scroll = () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    const thresholdsState = this.state.thresholds;
    thresholdsState.forEach(threshold => {
      if (scrollPosition >= threshold) {
        switch (threshold) {
          case 10:
            this.setScrollGA4State(threshold, 'scroll_starts');
            break;
          case 750:
            this.setScrollGA4State(threshold, 'scroll_1');
            break;
          case 1500:
            this.setScrollGA4State(threshold, 'scroll_2');
            break;
          case 2250:
            this.setScrollGA4State(threshold, 'scroll_3');
            break;
          case this.state.thresholds[0]:
            this.setScrollGA4State(this.state.thresholds[0], 1);
            break;
          default:
            break;
        }
      }
    });
  };

  showPrimePopupWidget = propsToPass => {
    const frmapp =
      this.props.query &&
      (this.props.query.frmapp === 'yes' ||
        this.props.query.frmapp === 'shorts');
    if (!frmapp) {
      return <PrimeScreen fcap="true" {...propsToPass} />;
    }
    return null;
  };

  getPrimeWidgets = () => {
    const { showToiplusNudges } = this.props;
    if (showToiplusNudges) {
      return (
        <>
          {this.showPrimePopupWidget({
            componentName: 'ToiplusSubscribeInlineWidget',
          })}
        </>
      );
    }
    return null;
  };

  renderInsertsForRow = sectionItem => {
    const { isLoggedIn } = this.props.userData;
    let ga4Type = sectionItem?.ga4Type;
    if (
      sectionItem.items &&
      Array.isArray(sectionItem.items) &&
      sectionItem.items.length > 2 &&
      sectionItem.items[2] &&
      Array.isArray(sectionItem.items[2]?.inserts) &&
      sectionItem.items[2]?.inserts.length > 0 &&
      sectionItem.items[2]?.inserts
    ) {
      ga4Type = sectionItem.items[2]?.inserts[0]?.ga4Type
        ? sectionItem.items[2]?.inserts[0]?.ga4Type
        : ga4Type;
    }
    return (
      <RenderInserts
        key={`${sectionItem.id}_inserts`}
        data={
          sectionItem.items &&
          sectionItem.items[2] &&
          sectionItem.items[2].inserts
        }
        timesTop10={this.props.timesTop10}
        isWapView={this.props.isWapView}
        addMarginTop={sectionItem.id === 'bestsellers'}
        newga={`click-${sectionItem.name}-rhs-`}
        isLoggedIn={isLoggedIn}
        toggleLoginBox={this.props.toggleLoginBox}
        ga4Type={ga4Type}
        ga4Category={sectionItem?.ga4Category}
        //isSubscribed={this.props.isSubscribed}
        isUShomepage
      />
    );
  };

  static renderInfocus(data, secname, sectitle) {
    return (
      <Infocus
        title={data.title}
        data={data.items}
        secname={secname}
        sectitle={sectitle}
      />
    );
  }

  fireMBGaEvents = () => {
    const gadata = {
      gaCategory: 'Web',
      gaAction: 'View',
      gaLabel: 'MB_US_HP_Widget',
    };
    sendGaThroughProps({ data: gadata });
  };

  setContextVal = () => {
    const geoCity = Cookie.get('geolocation');
    const { contextVal } = this.state;
    if (geoCity) {
      contextVal.geoCity = geoCity;
      this.setState({ contextVal: { ...contextVal } });
      this.setLanguageValInContext(geoCity, false);
    }
  };

  setLanguageValInContext = (
    geoCity,
    setInCookie,
    sectionId,
    //contextValue = this.state.contextVal,
  ) => {
    if (!geoCity) {
      return;
    }
    makeRequest
      .get(
        `https://ematrix.filmipop.com/v2/city/get?city_name=${geoCity}`,
        {},
        'skipfeedengine',
      )
      .then(data => {
        if (data && data.data && data.data.primary_language) {
          const contextVal = {
            geoCity,
            geoLang: data.data.primary_language,
            sectionId,
          };
          this.setState({ contextVal });
          if (setInCookie) {
            let domain = 'indiatimes.com';
            if (document.domain.indexOf('timesofindia.com') >= 0) {
              domain = 'timesofindia.com';
            }
            Cookie.set('geolocation', geoCity, 365, '/', domain);
            Cookie.set('geostate', data.data.state_code, 365, '/', domain);
            if (typeof this.props.loadGeoLocationData === 'function') {
              this.props.loadGeoLocationData();
            }
          }
        }
      });
  };

  static renderSectionSubHeader() {
    // return <UsElectHeader />;
    // return <IframeUSElection />;
  }

  render() {
    const {
      hpData = {},
      dataLoading,
      showToiPlusEntryPoints,
      currentCountry,
    } = this.props;
    const { isLoggedIn } = this.props.userData;
    const hpSectionArray = hpData.sections ? hpData.sections : [];
    let componentReturned = null;
    // let cardInsertContainer = null;
    // let cardInsertCoronaContainer = null;
    return (
      <UserPreferenceContext.Provider
        value={{
          ...this.state.contextVal,
          setLanguageVal: this.setLanguageValInContext,
        }}
      >
        <div>
          {/* <div>
          <IframeUSElection />
        </div> */}
          {this.getPrimeWidgets()}
          {hpSectionArray instanceof Array &&
            hpSectionArray.map((sectionItem = {}, indexVal) => {
              switch (sectionItem.tn) {
                case 'top_section_type_1': {
                  componentReturned = (
                    <InViewObserver
                      inViewCallback={() => {
                        this.setViewGA4Elements(sectionItem);
                      }}
                    >
                      <ErrorBoundary>
                        <HomePageTopLayout
                          sectionData={sectionItem}
                          isPrime={this.props.isPrime}
                          isLoggedIn={isLoggedIn}
                          userData={this.props.userData}
                          isInPageDock={this.props.isInPageDock}
                          className={sectionItem.className}
                          geoCityData={this.props.geoCityData}
                          isGccPage={this.props.isGccPage}
                        />
                      </ErrorBoundary>
                    </InViewObserver>
                  );
                  break;
                }
                case 'col_3_1_2_layout': {
                  componentReturned = (
                    <InViewObserver
                      inViewCallback={() => {
                        this.setViewGA4Elements(sectionItem);
                      }}
                    >
                      <CoverLayout
                        sectionData={sectionItem}
                        key={`${sectionItem.id}_${indexVal}`}
                        isWapView={this.props.isWapView}
                        geoCityData={this.props.geoCityData}
                        renderCallback={this.setScrollGAElements}
                        isUsHP
                      >
                        <RenderInserts
                          key={`${sectionItem.id}_inserts`}
                          data={
                            sectionItem.items &&
                            sectionItem.items[2] &&
                            sectionItem.items[2].inserts
                          }
                          isPrime={this.props.isPrime}
                          isWapView={this.props.isWapView}
                          isLoggedIn={isLoggedIn}
                          toggleLoginBox={this.props.toggleLoginBox}
                          newga={`${sectionItem.name}Section_Actions#`}
                          showToiPlusEntryPoints={showToiPlusEntryPoints}
                          ga4Type={sectionItem?.ga4Type}
                          ga4Category={sectionItem?.ga4Category}
                          isInPageDock={this.props.isInPageDock}
                          isUShomepage
                        />
                      </CoverLayout>
                    </InViewObserver>
                  );
                  break;
                }
                // case 'budget': {
                //   componentReturned = (
                //     <BudgetWidgetHP data={sectionItem} key="budget_hp" />
                //   );
                //   break;
                // }
                case 'sponser_iframe': {
                  const data = {
                    ...sectionItem,
                    name: '',
                    tn: 'iframe',
                    sendGA: evnttype => this.fireMBGaEvents(evnttype),
                  };
                  // TOIPR-64605: Added magic brick iframe on US Home page above city widget
                  // sectionItem  from uswebhomepagefeedspadata
                  componentReturned = (
                    <RenderInserts
                      data={[data]}
                      key={sectionItem.id}
                      isUShomepage
                    />
                  );
                  break;
                }
                case 'col_4_2_layout': {
                  componentReturned = (
                    <RowLayout
                      csr
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                      loadAjaxSectionData={this.props.loadAjaxSectionData}
                      // subSections={sectionItem.items ? sectionItem.items : null}
                      renderInsertsFn={this.renderInsertsForRow}
                      geoCityData={this.props.geoCityData}
                    >
                      {this.renderInsertsForRow(sectionItem)}
                    </RowLayout>
                  );
                  break;
                }
                case 'col_6_layout': {
                  componentReturned = (
                    <SixColumnLayout
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                      size={sectionItem.id === 'coronavirusPhoto' && 'small'}
                      gridRequired={sectionItem.gridRequired}
                      noOfCads={sectionItem.cardCount}
                      subSection={sectionItem.id === 'coronavirusPhoto'}
                    />
                  );
                  break;
                }
                case 'bannerslider': {
                  componentReturned = (
                    <BannerSlider
                      key={sectionItem.tn}
                      data={sectionItem}
                      gaAction="SpotlightBannerWidget_Click"
                      gaLabelPerfix="Spotlight_banner/click/"
                      onRendered={() => {
                        this.setScrollGAElements.call(this);
                      }}
                    />
                  );
                  break;
                }
                case 'banner': {
                  if (sectionItem.item && sectionItem.item.length > 0) {
                    componentReturned = (
                      <div
                        className={`${s.staticbanner} ${sectionItem.className ||
                          ''}`}
                      >
                        {sectionItem.border &&
                          sectionItem.border === 'top' && (
                            <InterSectionBorder border={sectionItem.border} />
                          )}
                        <div
                          className={`${s.innerWrapper} ${s.slugbannerouter}`}
                        >
                          {sectionItem.item.map((data, index) => (
                            <Link
                              to={data.wu}
                              data-newga={data.gaData || ''}
                              target={
                                data.target === '_blank' ? data.target : ''
                              }
                              aria-label={data.gaData}
                            >
                              {data.inviewGa === 'y' &&
                              data.gaCat &&
                              data.gaAc &&
                              data.gaLeb ? (
                                <ElementInView
                                  gaCategory={data.gaCat}
                                  gaLabel={data.gaLeb}
                                  gaAction={data.gaAc}
                                >
                                  <Image
                                    key={index}
                                    url={data.imgUrl}
                                    src={data.imgUrl}
                                    target="_blank"
                                    // width={width}
                                    title={data.title || ''}
                                    placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                                    lazyload
                                    alt="banner img"
                                  />
                                </ElementInView>
                              ) : (
                                <Image
                                  key={index}
                                  url={data.imgUrl}
                                  src={data.imgUrl}
                                  target="_blank"
                                  // width={width}
                                  title={data.title || ''}
                                  placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                                  lazyload
                                  alt="banner img"
                                />
                              )}
                            </Link>
                          ))}
                          {sectionItem.inserts &&
                            sectionItem.inserts.length > 0 && (
                              <div className={s.slugadboxhp}>
                                <RenderInserts
                                  key="bannerad_inserts"
                                  data={sectionItem.inserts}
                                  isPrime={this.props.isPrime}
                                  isWapView={this.props.isWapView}
                                  isLoggedIn={isLoggedIn}
                                  toggleLoginBox={this.props.toggleLoginBox}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    );
                    break;
                  }

                  componentReturned = (
                    <Image
                      url={sectionItem.imgUrl}
                      src={sectionItem.imgUrl}
                      overridelink={sectionItem.wu}
                      target="_blank"
                      // width={width}
                      title={sectionItem.title || ''}
                      imageClassName={s.bannerimg}
                      placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                      lazyload
                      alt="banner img"
                    />
                  );
                  break;
                }
                case 'gntech': {
                  componentReturned = (
                    <TechSection
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                      loadAjaxSectionData={this.props.loadAjaxSectionData}
                      showTechSectionLoader={this.props.showTechSectionLoader}
                      renderInsertsFn={this.renderInsertsForRow}
                      geoCityData={this.props.geoCityData}
                      newga={`${sectionItem.name}Section_Actions#`}
                    >
                      {this.renderInsertsForRow(sectionItem)}
                    </TechSection>
                  );
                  break;
                }
                case 'corona_widget': {
                  componentReturned = (
                    <CoronaWidget
                      data={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                    />
                  );
                  break;
                }
                case 'primeslider': {
                  // const isPrimeNotActiveUser = isPrimeNotActive(prcValue);
                  componentReturned = this.props.showToiPlusEntryPoints ? (
                    <>
                      <InViewObserver
                        inViewCallback={() => {
                          this.setViewGA4Elements(sectionItem);
                        }}
                      >
                        <PrimeSlider
                          key={`${sectionItem.id}_${indexVal}`}
                          data={sectionItem}
                          isPrime={this.props.isPrime}
                          country={currentCountry}
                        />
                      </InViewObserver>
                    </>
                  ) : null;
                  break;
                }
                case 'timesclubslider': {
                  componentReturned = (
                    <>
                      <TimesClubSlider
                        key={`${sectionItem.id}_${indexVal}`}
                        ga4Type={sectionItem?.ga4Type}
                        imgPixel={sectionItem?.imgPixel}
                        // data={sectionItem}
                      />
                    </>
                  );
                  break;
                }
                case 'masonry_layout': {
                  componentReturned = (
                    <MasonryLayout
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                    />
                  );
                  break;
                }
                case 'col_3_layout': {
                  componentReturned = (
                    <Lifestyle
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                      footer={Home.renderInfocus(
                        sectionItem.keywords,
                        `${_get(sectionItem, 'name', '')}Infocus`,
                        sectionItem.name,
                      )}
                    />
                  );
                  break;
                }
                case 'videos_section': {
                  if (
                    sectionItem.items instanceof Array &&
                    sectionItem.items.length > 0
                  ) {
                    componentReturned = (
                      <VideoLayout
                        key={`${sectionItem.id}_${indexVal}`}
                        sectionData={sectionItem}
                        loadAjaxSectionData={this.props.loadAjaxSectionData}
                      />
                    );
                  } else {
                    componentReturned = null;
                  }
                  break;
                }
                case 'entertainment': {
                  componentReturned = (
                    <Entertainment
                      key={`${sectionItem.id}_${indexVal}`}
                      sectionData={sectionItem}
                      loadAjaxSectionData={this.props.loadAjaxSectionData}
                      geoCityData={this.props.geoCityData}
                      showEntertainmentSectionLoader={
                        this.props.showEntertainmentSectionLoader
                      }
                      ga4Type={sectionItem?.ga4Type}
                      ga4Category={sectionItem?.ga4Category}
                      insertComp={RenderInserts}
                    />
                  );
                  break;
                }
                // TODO: Election Widget
                case 'election': {
                  return (
                    <ErrorBoundary>
                      <InViewObserver
                        inViewCallback={() => {
                          analyticsWrapper('ga4', {
                            event: 'user_shown',
                            type: `exitpoll_widget`,
                          });
                        }}
                      >
                        <div id="tileyeDiv" />
                        <div className={s.electionHomePageWraper}>
                          <ElectionWidgetMainWrapper
                            isHomePage
                            isWapView={this.props.isWapView}
                            isPowerByAd={this.props.isPowerByAd}
                            isPowerByAdActive={this.props.isPowerByAdActive}
                            tabs={sectionItem.tabs}
                            hideETheading
                            isUShomepage
                            page="home"
                          />
                        </div>
                      </InViewObserver>
                    </ErrorBoundary>
                  );
                }
                // case 'dailypuzzle':
                //   componentReturned = (
                //     <ElementInView
                //       gaCategory="gameswidget_hp"
                //       gaLabel="web"
                //       gaAction="view_widget"
                //     >
                //       <DailyPuzzles
                //         sectionData={sectionItem}
                //         key={sectionItem.id}
                //         title="PLAY EXCITING PUZZLES & GAMES"
                //         gaMetaData={{ EC: 'gameswidget_hp' }}
                //         iconImageIdMap={{
                //           cw: 88709998,
                //           sudoku: 88710081,
                //           ws: 88710085,
                //           wf: 88710095,
                //         }}
                //         hideShowMoreLink
                //         gamesEntryWidget
                //       />
                //     </ElementInView>
                //   );
                //   break;
                case 'col_6_ad': {
                  componentReturned = (
                    <RenderInserts
                      data={sectionItem.data}
                      key={`${sectionItem.id}_${indexVal}`}
                      isUShomepage
                    />
                  );
                  break;
                }
                case 'affilaite_content': {
                  componentReturned = (
                    <AffiliatesContent
                      type={sectionItem.type}
                      filters={{
                        pagename: 'home',
                      }}
                      key={`${sectionItem.id}_${indexVal}`}
                    />
                  );
                  break;
                }
                case 'keywords': {
                  componentReturned = (
                    <LinksList
                      cssSelector="infocus_us"
                      sectionData={sectionItem}
                      key={`${sectionItem.id}_${indexVal}`}
                    />
                  );
                  break;
                }
                case 'affiliate_widget':
                  componentReturned = (
                    <AffiliateWidgetMain
                      isWapView={this.props.isWapView}
                      url={
                        this.props.isPrime
                          ? sectionItem.dataUrl
                          : sectionItem.data.dataUrl
                      }
                      slidesToShow={5.5}
                      slidesToScroll={5}
                      key={`${sectionItem.id}_${indexVal}`}
                    />
                  );
                  break;
                // case 'plane_layout_with_author':
                //   componentReturned = (
                //     <PlaneLayoutWithAuthor
                //       sectionItem={sectionItem}
                //       key={`${sectionItem.id}_${indexVal}`}
                //       timesTop10={this.props.timesTop10}
                //       isWapView={this.props.isWapView}
                //       cardInserts={cardInserts.inserts[`div-${indexVal}`]}
                //       isUsHomepage
                //       apiUrl={CORONAVIRUS_CARDS_HOME_US_JSON_URL}
                //     />
                //   );
                //   break;
                case 'ad':
                  componentReturned = (
                    <RenderAds
                      adObject={sectionItem}
                      key={`${sectionItem.tn}_${indexVal}`}
                      isWapView={false}
                    />
                  );
                  break;
                case 'customslider': {
                  componentReturned = (
                    <CustomSlider
                      key={`${sectionItem.id}_${indexVal}`}
                      data={sectionItem}
                    />
                  );
                  break;
                }
                case 'ipl_widget':
                  componentReturned = (
                    <Iplwidget
                      key={sectionItem.id}
                      sectionData={sectionItem}
                      apiURL={sectionItem.path}
                      gaEventCategory="-US-NHP1"
                      isAppView={isTablet()}
                    />
                  );
                  break;
                default: {
                  componentReturned = null;
                }
              }
              // cardInsertContainer =
              //   cardsInsertsLite &&
              //   cardsInsertsLite.inserts &&
              //   cardsInsertsLite.inserts[`div-${indexVal}`];
              // if (cardInsertContainer)
              //   cardInsertContainer = (
              //     <NewscardComponent
              //       isWapView={this.props.isWapView}
              //       cardsInsertsLite={
              //         cardsInsertsLite.inserts[`div-${indexVal}`]
              //       }
              //       slot={`div-${indexVal}`}
              //       apiUrl={CORONAVIRUS_CARDS_HOME_US_JSON_URL}
              //       tokens={
              //         cardsInsertsLite.whoami && cardsInsertsLite.whoami.tokens
              //       }
              //       campaignName={
              //         cardsInsertsLite.inserts[`div-${indexVal}`] &&
              //         cardsInsertsLite.inserts[`div-${indexVal}`].campaign_name
              //       }
              //       location={this.props.location}
              //       gaCat="WEB-US-NHP1"
              //       pageName="ToiHome"
              //     />
              //   );
              return [
                // cardInsertCoronaContainer,
                // cardInsertContainer,
                componentReturned,
              ];
            })}
          {hpData.pagination && (
            <Paginate
              data={hpData.pagination}
              dataLoading={dataLoading}
              skew={900}
              loadPageCallback={pageNum => this.props.loadPageCallback(pageNum)}
            />
          )}
          {/* <TimesClubWidgetLoaderWithPopup isWapView={false} /> */}
        </div>
      </UserPreferenceContext.Provider>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxSectionData: params => {
    dispatch(loadAjaxSectionData(params));
  },
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  loadToiPlusConfig: params => {
    dispatch(loadToiPlusConfig(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
});

const mapStateToProps = state => ({
  hpData: state.homepage_us.data,
  timesTop10: state.timesTop10,
  showEntertainmentSectionLoader:
    state.homepage_us.showEntertainmentSectionLoader,
  showCitySectionLoader: state.homepage_us.showCitySectionLoader,
  showElectionSectionLoader: state.homepage_us.showElectionSectionLoader,
  dataLoading: state.homepage_us.dataLoading,
  showTechSectionLoader: state.homepage_us.showTechSectionLoader,
  isPrime: state.isPrime,
  userData: _get(state, 'login.userData', {}),
  ssrGeoCode: state.ssrGeoCode,
  geoCityData: state.geo.cityData,
  currentCountry: state.geo.currentCountry,
  //isSubscribed: state.timesTop10 && state.timesTop10.is_Subscribed,
  showToiPlusEntryPoints:
    state.toiplusconfig && state.toiplusconfig.showToiPlusEntryPoints,
  showToiplusNudges:
    state.toiplusconfig && state.toiplusconfig.showToiPlusNudges,
});

Home.propTypes = {
  routeParams: PropTypes.shape({
    msid: PropTypes.string,
  }),
  hpData: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  timesTop10: PropTypes.shape({}),
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
  }).isRequired,
  loadAjaxSectionData: PropTypes.func.isRequired,
  showTechSectionLoader: PropTypes.bool,
  showEntertainmentSectionLoader: PropTypes.bool,
  showCitySectionLoader: PropTypes.bool,
  showElectionSectionLoader: PropTypes.bool,
  dataLoading: PropTypes.bool,
  loadPageCallback: PropTypes.func,
  isWapView: PropTypes.bool,
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  isPrime: PropTypes.bool,
  ssrGeoCode: PropTypes.string,
  electionFlag: PropTypes.bool,
  electionData: PropTypes.shape({}),
  cardsInsertsLite: PropTypes.objectOf({}),
  geoCityData: PropTypes.shape({}),
  //isSubscribed: PropTypes.bool,
  currentCountry: PropTypes.string,
  loadToiPlusConfig: PropTypes.func.isRequired,
  showToiPlusEntryPoints: PropTypes.bool,
  showToiplusNudges: PropTypes.bool,
  location: PropTypes.string,
  refreshTime: PropTypes.number,
};
Home.defaultProps = {
  // overlayMsid: '',
  routeParams: {},
  showTechSectionLoader: false,
  showEntertainmentSectionLoader: false,
  showCitySectionLoader: false,
  showElectionSectionLoader: false,
  geoCityData: {},
  dataLoading: false,
  loadPageCallback: () => {},
  isWapView: false,
  isPrime: false,
  timesTop10: undefined,
  ssrGeoCode: undefined,
  electionFlag: false,
  electionData: {},
  cardsInsertsLite: {},
  //isSubscribed: undefined,
  currentCountry: '',
  showToiPlusEntryPoints: false,
  showToiplusNudges: false,
  location: null,
  refreshTime: 0,
};

export default connect(mapStateToProps, mapDispatchtoProps)(Home);

Home.contextTypes = {
  store: PropTypes.object.isRequired,
};
